// Section témoignages — préparée mais MASQUÉE tant qu'aucun témoignage réel n'est disponible.
// Pour l'activer : ajouter de vrais témoignages dans TESTIMONIALS ci-dessous.
// Aucun faux témoignage ne doit être créé.
import { Reveal } from "@/components/okaia/Reveal";

const TESTIMONIALS = []; // ex: { name: "Prénom N.", role: "Créatrice d'entreprise", text: "..." }

export const Testimonials = () => {
  if (TESTIMONIALS.length === 0) return null;
  return (
    <section id="temoignages" data-testid="section-temoignages" className="bg-[#F0EBE1] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <p className="okaia-overline mb-6 text-[#B39265]">Ils en parlent</p>
          <h2 className="font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">Témoignages</h2>
        </Reveal>
        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <blockquote className="border border-[#C8A97E]/40 bg-[#F9F8F6] p-8">
                <p className="font-serif-display text-lg italic leading-relaxed text-[#0B2215]">« {t.text} »</p>
                <footer className="mt-6 text-sm font-light text-[#4A5A52]">
                  <span className="font-medium text-[#0B2215]">{t.name}</span> — {t.role}
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
